<div class="styled-select {{ className }}" [ngClass]="{'has-value': selectedOption !== null}" [formGroup]="parentForm">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selectOption($event.option.value)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{ option.text }}
    </mat-option>
  </mat-autocomplete>
  <input type="text" name="autocomplete-input" id="autocomplete-input" class="no-validation-icon" [placeholder]="placeholder" matInput [formControl]="input" [matAutocomplete]="auto" autocomplete="off">
  <a class="clear" (click)="onClear()"><i class="far fa-times" aria-hidden="true"></i></a>
</div>
